const convertMongoDateToNormalDate=(mongoDate: any): string | null => {
    if (!mongoDate) {
      return null; // Handle null or undefined input
    }
  
    try {
      const date = new Date(mongoDate);
      if (isNaN(date.getTime())) {
        return null; // Handle invalid date
      }
  
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const day = String(date.getDate()).padStart(2, '0');
  
      return `${year}-${month}-${day}`; 
     
    } catch (error) {
      console.error("Error converting MongoDB date:", error);
      return null; 
    }
  }
  
  const mongoDateExample = new Date("2023-10-27T10:00:00Z"); 
  const normalDateString = convertMongoDateToNormalDate(mongoDateExample);
  
  if (normalDateString) {
    console.log("Normal date:", normalDateString);
  } else {
    console.log("Invalid MongoDB date or error occurred.");
  }
  

  
  export default convertMongoDateToNormalDate